module.exports = __webpack_public_path__ + "blackflowerarranged.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackflowerarranged.png
// module id = 853
// module chunks = 0